export default __webpack_public_path__ + "static/media/step-5@3x.0f9e76bd.png";